import React from 'react';
import OneToTenCourse from './OneToTenCourse/OneToTenCourse';

const OneToTen = () => {
    return (
        <div className='container-fluid p-5' style={{marginTop:'80px'}}>
           <OneToTenCourse/>
        </div>
    );
};

export default OneToTen;